const DEFAULT_CONST = {
  PAGE_SIZE: 15,
  PAGE_INDEX: 0,
};

export default DEFAULT_CONST;
